import { getAccessToken } from '@/lib/auth-client';
import { API_BASE } from '@/lib/api';

export interface UploadResponse {
  url: string;
  fileName: string;
}

export async function uploadAdminImage(
  file: File,
  folder: string = 'general',
): Promise<UploadResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);

  // Use fetch directly (not authFetch) so the browser auto-sets
  // the Content-Type multipart boundary for FormData bodies.
  const token = getAccessToken();
  const res = await fetch(`${API_BASE}/api/admin/upload`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.error || 'Upload failed');
  }

  return res.json();
}
